/**
 * Redux Toolkit slice for auth state, manages user auth status (isAuthenticated), JWT Tokens, user info.
 * This slice stores user data after MSAL login.
 * TLDR; for auth state management
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  profile: null,
  isJwtRequested: false,
  isJwtOAIRequested: false,
  graphJwt: null,
  photo: null, // Stores user photo URL
  // Add other fields as needed
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.profile = action.payload;
      state.isAuthenticated = true;
    },
    setPhoto(state, action) {
      state.photo = action.payload;
    },
    setGraphJWT(state, action) {
      state.graphJwt = action.payload;
    },
    setJwtRequested(state, action) {
      state.isJwtRequested = action.payload;
    },
    setJwtOAIRequested(state, action) {
      state.isJwtOAIRequested = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.profile = null;
      state.isJwtRequested = false;
      state.isJwtOAIRequested = false;
      state.graphJwt = null;
      state.photo = null;
    },
  },
});

export const { setUser, setGraphJWT, setJwtRequested, setJwtOAIRequested, setPhoto, logout } = authSlice.actions;
export interface AuthState {
  isAuthenticated: boolean;
  profile: any;
  isJwtRequested: boolean;
  isJwtOAIRequested: boolean;
  graphJwt: string | null;
  photo: string | null;
}

export const authSelector = (state: { auth: AuthState }) => state.auth;
export default authSlice.reducer;
